export const adminLinks = [
  'categories',
  'locations',
  'settings',
  'staff'
];
